import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    container: {},
    list: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        width: '100%',
        marginTop: 32
    },
    table: {
        marginTop: 32
    },
    notFound: {
        fontWeight: 700,
        fontSize: 24,
        lineHeight: '120%',
        color: '#282D31',
        textAlign: 'center'
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    total: {
        margin: 0,
        color: '#232323',
        fontSize: 20,
        fontWeight: 700,
        lineHeight: '150%'
    },
    buttons: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
    },
    button: {
        borderRadius: 12,
        padding: 12,
        background: '#F8F8F8 !important',
        color: '#000000 !important',
        ['& svg']: {
            width: 16,
            height: 16
        }
    },
    active: {
        background: '#232323 !important',
        color: '#fff !important'
    },
    occurrences: {
        marginTop: 16
    },
    paginator: {
        marginTop: 32
    }
});
